module.exports = __webpack_public_path__ + "img/wayly_logo.fbfc9db3.png";